import {Component, OnDestroy, OnInit} from '@angular/core';
import SewingPatternInterface from '../../../models/sewing-pattern.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {PatternRepository} from '../../../repositories/pattern.repository';
import {InspirationRepository} from '../../../repositories/inspiration.repository';
import {InspirationService} from '../../../services/inspiration.service';

@Component({
    selector: 'app-inspiration',
    templateUrl: './inspiration.page.html',
    styleUrls: ['./inspiration.page.css'],
})
export class InspirationPage implements OnInit, OnDestroy {

    inspiration: any;

    private inspirationId$;

    public saved = false;

    constructor(private route: ActivatedRoute,
                private inspirationRepository: InspirationRepository,
                private inspirationService: InspirationService,
                private router: Router) {
    }

    ngOnDestroy(): void {
        this.inspirationId$?.unsubscribe();
    }

    ngOnInit(): void {
        this.inspirationId$ = this.route.params.subscribe(params => {
            this.inspiration = this.inspirationRepository.getByIdOrFirst(+params.inspirationId);

            this.inspirationService.hasInspirationSaved(this.inspiration.id)
                .then((saved) => this.saved = saved);
        });
    }

    saveInspiration() {
        this.inspirationService.saveInspiration(this.inspiration.id)
            .then(() => this.saved = true);
    }

    removeFromSavedInspirations() {
        this.inspirationService.removeInspiration(this.inspiration.id)
            .then(() => this.saved = false);
    }

}
